import gql from 'graphql-tag'

const GET_ALL = gql `
  query getKategoriAgenda($perPage: Int!, $page: Int, $where: KategoriAgendaWhereWhereConditions){
    kategoriAgenda(first: $perPage, page: $page, where: $where){
      data{
        id
        uuid
        nama
        deskripsi,
        warna
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

const GET_DETAIL = gql `
    query find($id: String!){
        kategoriAgenda(uuid : $id){
            id,
            uuid,
            nama,
            deskripsi,
            warna
        }
    }
`;

const CREATE = gql `
    mutation($input:KategoriAgendaCreateInput!){
        kategoriAgendaCreate(input:$input){
            id,
            uuid,
            nama,
            deskripsi,
            warna
        }
    }
`

const UPDATE = gql `
    mutation($id: ID!, $input:KategoriAgendaUpdateInput!){
        kategoriAgendaUpdate(id:$id, input:$input){
            uuid,
        }
    }
`

export {
  GET_ALL, CREATE, GET_DETAIL, UPDATE
}